export default (params) => ({
  trigger: {
    name: 'cross_sell_alternatives.close_overlay',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'configurator_overlay',
          'accessory_checkbox_overlay',
          'add_to_cart_page_overlay',
          'options_row_overlay',
          'add_to_cart_overlay_overlay',
          'product_type_section_alternative_overlay',
          'recommended_accessories_alternative_overlay',
        ],
      },
    },
    event: {
      name: 'close',
    },
  },
});
